export default __webpack_public_path__ + "static/media/Q3_1.ffe8df38.jpg";